<template>
  <div>

    <data-table
        :title="title"
        url="/contractors"
        :fields="fields"
        ref="contractors-table"
        table-ref="contractors-table"
        detail-component="contractor-detail-row" />
<!--        :add-action="noAdd ? null : action" /> -->

 </div>

</template>

<script>
import Vue from 'vue'

import SiteMixins from '@/mixins/SiteMixins'
import SiteContractorsDetails from '@/components/sites/finance/contractors/SiteContractorsDetails'

/*
import InvoiceControls from '@/components/finance/invoice/InvoiceControls'

import InvoiceAction from '@/components/actions/InvoiceAction'

Vue.component('invoice-controls', InvoiceControls)
*/
Vue.component('contractor-detail-row', SiteContractorsDetails)

export default {
  mixins: [SiteMixins],
/*
  components: {
    InvoiceAction
  },

*/

  props: {

    siteData: {
      type: Object,
      required: true
    },

    sharerId: {
      type: Number,
      default: null
    },

    title: {
      type: String,
      default: 'Contractors Invoices'
    },

    showAmounts: {
      type: Boolean,
      default: true
    },

    noAdd: {
      type: Boolean,
      default: true
    },

    noDelete: {
      type: Boolean,
      default: true
    },

    editMode: {
      type: Boolean,
      default: false
    }

  },



  data () {

    return {

//      action: InvoiceAction,
      fields: [
        {
          name: 'site.siteId',
          title: 'Site ID',
        },
        {
          name: 'site.siteName',
          title: 'Site Name',
        },
        {
          name: 'contractor.shortName',
          title: 'Short Name',
        },
        {
          name: 'type',
          title: 'Type',
          sortField: 'type'
        },
        {
          name: 'summary',
          title: 'Summary',
          sortField: 'summary',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'started',
          title: 'Started',
          callback: this.formatDateTime,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'ended',
          title: 'Ended',
          callback: this.formatDateTime,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatNumber,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'tax',
          title: this.taxLabel,
          callback: this.formatNumber,
          visible: this.showTax(),
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'total',
          title: 'TOTAL',
          callback: this.formatNumber,
          visible: this.showTax()
        },
        {
          name: '__slot:admin-action',
          visible: (this.isSuper() || this.isManager('finance'))
        }
      ]

  }

  } // data

}
</script>
